module.exports = tvg.deps["styled-components"]["styled-components-6-R18"];